import { cva } from 'cva'

export const flexStyle = cva({
  base: ['flex'],

  variants: {
    direction: {
      horizontal: ['flex-row'],
      vertical: ['flex-col'],
    },
  },

  defaultVariants: {
    direction: 'horizontal',
  },
})
